import { render } from "./UpToDate.vue?vue&type=template&id=3eff38c0&scoped=true"
import script from "./UpToDate.vue?vue&type=script&lang=js"
export * from "./UpToDate.vue?vue&type=script&lang=js"

import "./UpToDate.vue?vue&type=style&index=0&id=3eff38c0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eff38c0"]])

export default __exports__